import React from 'react';
import { observer } from 'mobx-react';
import {
  mdiFormatHorizontalAlignCenter,
  mdiEarthBox,
  mdiImageFilterHdr,
  mdiWaves,
  mdiCircleExpand,
  mdiWaterOutline,
  mdiPipeDisconnected,
  mdiBulldozer,
  mdiCogs,
} from '@mdi/js';
import Icon from '@mdi/react';
import { NavLink, useParams } from 'react-router-dom';
import padIcon from '../../../assets/images/pad-icon.svg';
import ugoIcon from '../../../assets/images/ugo-icon.svg';
import stores from 'cd-eft/models/Stores';
import { DesignSettings } from '../DesignSettings';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { appConfig } from 'cd-eft/config/AppConfig';
import './leftSideMenu.scss';

const { userProfileStore, designStore, waterwayDesignStore } = stores.AppStore;

const LeftSideMenuComponent = () => {
  const { projectId }: any = useParams();

  const handleWaterwayClick = () => {
    if ((waterwayDesignStore.currentWorkflowStep === 'waterway-input' && !waterwayDesignStore.waterwayInputsPageInputsChange) || (waterwayDesignStore.currentWorkflowStep === 'design-waterway' && designStore.wdtGroupsLength === 0)) {
      waterwayDesignStore.reset();
    }
  };
  // create a view-model that will persist for the lifetime of the component

  return (
    <nav className="design-side-menu" aria-label="Design Menu">
      {/* loader */}
      {designStore.isLoading &&
        ![7, 19, appConfig.hardCodes.designElementTypeUGO, appConfig.hardCodes.designElementTypeTerrace].includes(designStore.designElementTypeId) && !window.location.pathname.includes('/terrace') && (
          <Loader message={designStore.loadingMsg} className="design-container-loader" />
        )}
      <span className="mr-1 text-white">Design</span>

      <NavLink
        to={projectId === '' ? '/design/surface' : `/design/${projectId}/surface`}
        activeClassName="active-design-item"
        className="design-side-menu-button"
      >
        <Icon path={mdiEarthBox} title="Surface" size={1} />
        <div>Surface</div>
      </NavLink>

      <NavLink
        to={projectId === '' ? '/design/alignment' : `/design/${projectId}/alignment`}
        activeClassName="active-design-item"
        className="design-side-menu-button"
      >
        <Icon path={mdiFormatHorizontalAlignCenter} title="Alignment" size={1} />
        <div>Alignment</div>
      </NavLink>

      <NavLink
        to={projectId === '' ? '/design/terrace' : `/design/${projectId}/terrace`}
        activeClassName="active-design-item"
        className="design-side-menu-button"
      >
        <Icon path={mdiImageFilterHdr} title="Terrace" size={1} />
        <div>Terrace</div>
      </NavLink>

      <NavLink
        to={projectId === '' ? '/design/ugo' : `/design/${projectId}/ugo`}
        activeClassName="active-design-item"
        className="design-side-menu-button"
      >
        <img id="ugo-icon" src={ugoIcon} alt="UGO icon" />
        <div>UGO</div>
      </NavLink>

      <NavLink
        to={projectId === '' ? '/design/waterway' : `/design/${projectId}/waterway`}
        activeClassName="active-design-item"
        className="design-side-menu-button"
        onClick={handleWaterwayClick}
      >
        <Icon path={mdiWaves} title="Waterway" size={1} />
        <div>Waterway</div>
      </NavLink>

      <NavLink
        to={projectId === '' ? '/design/pit' : `/design/${projectId}/pit`}
        activeClassName="active-design-item"
        className="design-side-menu-button"
      >
        <img id="pad-icon" src={padIcon} alt="pad icon" />
        <div>Pit</div>
      </NavLink>

      <NavLink
        to={projectId === '' ? '/design/pond' : `/design/${projectId}/pond`}
        activeClassName="active-design-item"
        className="design-side-menu-button"
      >
        <Icon path={mdiWaterOutline} title="Pond" size={1} />
        <div>Pond</div>
      </NavLink>

      <NavLink
        to={projectId === '' ? '/design/pipeline' : `/design/${projectId}/pipeline`}
        activeClassName="active-design-item"
        className="design-side-menu-button"
      >
        <Icon path={mdiPipeDisconnected} title="Pipeline" size={1} />
        <div>Pipeline</div>
      </NavLink>

      <NavLink
        to={projectId === '' ? '/design/pad' : `/design/${projectId}/pad`}
        activeClassName="active-design-item"
        className="design-side-menu-button"
      >
        <Icon path={mdiCircleExpand} title="Pit" size={1} />
        <div>Pad</div>
      </NavLink>

      <NavLink
        to={projectId === '' ? '/design/land-leveling' : `/design/${projectId}/land-leveling`}
        activeClassName="active-design-item"
        className="design-side-menu-button"
      >
        <Icon path={mdiBulldozer} title="Land Leveling" size={1} />
        <div>Land Leveling</div>
      </NavLink>

      <NavLink
        to="#"
        className={`design-side-menu-button ${!userProfileStore.applicationFlags.enablesettings ? 'disabled' : ''}`}
        aria-disabled={!userProfileStore.applicationFlags.enablesettings}
        data-testid="side-menu-settings"
        onClick={(e) => {
          e.preventDefault();
          if (userProfileStore.applicationFlags.enablesettings) {
            designStore.showSettingsPopup = !designStore.showSettingsPopup;
            designStore.currentDesignSettingsTab = 'General';
          }
        }}
      >
        <Icon path={mdiCogs} title="Settings" size={1} />
        <div>Settings</div>
      </NavLink>

      {/* <div>
        <Icon path={mdiMapSearchOutline} title="" size={1} />
        <div>Measure</div>
      </div>
      <div>
        <Icon path={mdiMapSearchOutline} title="" size={1} />
        <div>Edit</div>
      </div>
      <div>
        <Icon path={mdiMapSearchOutline} title="" size={1} />
        <div>Draw</div>
      </div>
      <div>
        <Icon path={mdiMapSearchOutline} title="" size={1} />
        <div>Layers</div>
      </div> */}

      {designStore.showSettingsPopup && <DesignSettings />}
    </nav>
  );
};

export const LeftSideMenu = observer(LeftSideMenuComponent);
